export default {
  header: 'Inventory Management',
  groupKey: 'inventorymanagement',
  filters: [

    {
      text: 'Inventory Items',
      value: 'inventoryGrid',
    },

    {
      text: 'Add Inventory',
      value: 'addInventory',
    },
    {
      text: 'Download Inventory',
      value: 'downloadInventory',
    },
    {
      text: 'Upload Inventory',
      value: 'uploadInventory',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/config/searchFilters/InventoryManagementFilters.js